export const siteInfo = {
  name: '91在线视频',
  title: '91在线视频-91年国产影片视频与91国产视频在线观看 | 国产电影电视剧全集免费高清不缓冲',
  slogan: '国产影视，一网打尽，畅享高清',
  description: '91在线视频汇聚海量国产电影、电视剧、综艺节目资源，每日更新最新热播内容，全站高清画质不缓冲，支持多端同步观看。无论经典老片还是最新热剧，这里都是您追剧观影的首选平台。',
  stats: [
    { label: '影片资源', value: '12,800+' },
    { label: '每日更新', value: '60+' },
    { label: '高清画质', value: '1080P' },
  ],
};

export const carouselItems = [
  {
    id: 1,
    title: '2026暑期档国产大片特辑',
    tag: '热播推荐',
    summary: '暑期强档集结，动作、喜剧、悬疑类型全覆盖，多部票房黑马线上首播，精彩不容错过。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20summer%20blockbuster%20movie%20poster%20collage%2C%20warm%20cinematic%20lighting%2C%20dramatic%20composition%2C%20red%20and%20gold%20accents%2C%20film%20strip%20texture%2C%20artistic%20abstract%20style%2C%20rich%20contrast%2C%20movie%20theater%20atmosphere&width=800&height=450&seq=carousel-1&orientation=landscape',
  },
  {
    id: 2,
    title: '国产悬疑剧高分盘点',
    tag: '编辑精选',
    summary: '烧脑推理、心理博弈、社会派悬疑……精选近两年豆瓣8分以上国产悬疑佳作，一次看过瘾。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20Chinese%20thriller%20drama%20visual%2C%20dark%20atmospheric%20scene%20with%20warm%20amber%20light%2C%20foggy%20street%2C%20shadowy%20figures%2C%20cinematic%20noir%20style%2C%20film%20grain%20texture%2C%20suspenseful%20mood%2C%20deep%20red%20undertones&width=800&height=450&seq=carousel-2&orientation=landscape',
  },
  {
    id: 3,
    title: '经典国产喜剧回顾',
    tag: '怀旧经典',
    summary: '从港式无厘头到内地黑色幽默，那些年笑到停不下来的国产喜剧片，重温欢笑时光。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20film%20retro%20collage%20with%20warm%20vintage%20tones%2C%20playful%20characters%20silhouettes%2C%20golden%20hour%20lighting%2C%20nostalgic%20cinema%20aesthetic%2C%20film%20reel%20elements%2C%20joyful%20atmosphere%2C%20artistic%20arrangement&width=800&height=450&seq=carousel-3&orientation=landscape',
  },
  {
    id: 4,
    title: '国产古装剧服化道赏析',
    tag: '深度解析',
    summary: '从服饰纹样到场景布置，走进国产古装剧的精美幕后，领略东方美学的极致表达。',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20costume%20drama%20aesthetic%2C%20intricate%20silk%20robes%20with%20embroidery%2C%20ancient%20palace%20interior%2C%20warm%20candlelight%2C%20golden%20and%20crimson%20fabrics%2C%20soft%20focus%2C%20elegant%20composition%2C%20cultural%20heritage%20style&width=800&height=450&seq=carousel-4&orientation=landscape',
  },
  {
    id: 5,
    title: '2026国产综艺新趋势',
    tag: '行业观察',
    summary: '慢综艺回归、文化类爆发、素人嘉宾崛起——今年国产综艺的创新之路与热门IP盘点。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20studio%20set%20with%20colorful%20lighting%2C%20modern%20stage%20design%2C%20warm%20spotlights%2C%20creative%20geometric%20patterns%2C%20vibrant%20atmosphere%2C%20entertainment%20production%20aesthetic%2C%20professional%20broadcast%20environment&width=800&height=450&seq=carousel-5&orientation=landscape',
  },
  {
    id: 6,
    title: '国产纪录片高分推荐',
    tag: '口碑佳作',
    summary: '从自然地理到人文历史，国产纪录片近年佳作频出，用镜头讲述最真实的中国故事。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20documentary%20cinematography%2C%20vast%20natural%20landscape%20with%20warm%20sunlight%2C%20mountains%20and%20rivers%2C%20aerial%20perspective%2C%20golden%20hour%20glow%2C%20artistic%20documentary%20style%2C%20rich%20earthy%20tones%2C%20majestic%20scenery&width=800&height=450&seq=carousel-6&orientation=landscape',
  },
];

export const indexItems = [
  { id: 1, title: '热播电视剧', icon: 'ri-tv-line', count: '326部', desc: '最新国产剧集每日更新' },
  { id: 2, title: '国产电影', icon: 'ri-film-line', count: '1,892部', desc: '院线大片与经典影片' },
  { id: 3, title: '热门综艺', icon: 'ri-live-line', count: '458档', desc: '卫视综艺与网络独播' },
  { id: 4, title: '纪录片', icon: 'ri-earth-line', count: '612部', desc: '自然人文高分纪录片' },
  { id: 5, title: '动漫动画', icon: 'ri-emotion-line', count: '1,043部', desc: '国创动漫与经典动画' },
  { id: 6, title: '动作武侠', icon: 'ri-sword-line', count: '537部', desc: '功夫武侠经典合集' },
  { id: 7, title: '悬疑推理', icon: 'ri-search-eye-line', count: '294部', desc: '烧脑悬疑高分推荐' },
  { id: 8, title: '喜剧搞笑', icon: 'ri-emotion-happy-line', count: '618部', desc: '轻松一刻笑料不断' },
  { id: 9, title: '古装历史', icon: 'ri-ancient-gate-line', count: '421部', desc: '古风国韵历史大剧' },
];

export const commentsData = [
  {
    id: 1,
    name: '影视迷小李',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20circle%20avatar%20placeholder%2C%20coral%20gradient%2C%20minimalist%20design%2C%20clean%20background&width=64&height=64&seq=avatar-1&orientation=squarish',
    time: '2小时前',
    content: '这个平台资源太全了！想看的国产剧基本都有，画质也很清晰，终于不用到处找了。推荐给身边好几个朋友了。',
    likes: 128,
  },
  {
    id: 2,
    name: '追剧达人阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20orange%20gradient%20circle%20avatar%2C%20simple%20geometric%20design%2C%20clean%20aesthetic%2C%20soft%20texture&width=64&height=64&seq=avatar-2&orientation=squarish',
    time: '5小时前',
    content: '更新速度真的快，昨晚刚播的剧集今天就能看了，而且不卡顿，体验很好。希望能一直保持这样的更新频率。',
    likes: 96,
  },
  {
    id: 3,
    name: '老影迷张叔',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20amber%20gradient%20circle%20avatar%20placeholder%2C%20minimal%20style%2C%20clean%20background%2C%20geometric%20abstract&width=64&height=64&seq=avatar-3&orientation=squarish',
    time: '1天前',
    content: '找到了很多小时候看过的老国产片，特别感动。分类清晰，搜索方便，收藏功能也好用，给满分！',
    likes: 203,
  },
  {
    id: 4,
    name: '综艺控小美',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20coral%20pink%20gradient%20minimalist%20circle%20avatar%2C%20abstract%20simple%20design%2C%20soft%20color%2C%20clean%20background&width=64&height=64&seq=avatar-4&orientation=squarish',
    time: '2天前',
    content: '综艺专区做得很好，按类型和热度分类一目了然。周末宅家刷综艺的快乐源泉，陪伴感满满。',
    likes: 87,
  },
];

export const featuresData = [
  { id: 1, title: '海量片库', desc: '收录超12800部国产影视资源，涵盖电影、电视剧、综艺、纪录片等全品类内容。', icon: 'ri-database-2-line' },
  { id: 2, title: '极速播放', desc: '采用智能CDN加速与P2P分发技术，全站高清画质流畅播放，告别卡顿与缓冲等待。', icon: 'ri-speed-up-line' },
  { id: 3, title: '每日更新', desc: '7×24小时内容运营团队，第一时间同步上线最新国产剧集、综艺节目和院线影片。', icon: 'ri-refresh-line' },
  { id: 4, title: '多端同步', desc: '支持电脑、平板、手机无缝切换，观看记录与收藏列表实时同步，随时随地继续追剧。', icon: 'ri-device-line' },
  { id: 5, title: '免费观影', desc: '全站内容免费在线观看，无需注册即可畅享高清画质，零门槛享受国产影视盛宴。', icon: 'ri-vip-crown-line' },
];

export const cardsData = [
  {
    id: 1,
    title: '《长安十二时辰》精编版上线',
    tag: '热播剧集',
    desc: '马伯庸原著改编，雷佳音、易烊千玺主演的古装悬疑大剧精编版独家上线，48集浓缩为30集精华版。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20lanterns%2C%20Tang%20dynasty%20architecture%2C%20warm%20golden%20lighting%2C%20dramatic%20atmosphere%2C%20cinematic%20composition%2C%20historical%20drama%20aesthetic%2C%20rich%20textures&width=600&height=340&seq=card-1&orientation=landscape',
  },
  {
    id: 2,
    title: '2026金鸡奖获奖影片专题',
    tag: '影坛盛事',
    desc: '第38届金鸡奖获奖及提名影片全收录，最佳影片、最佳导演、最佳男女主角作品一网打尽。',
    image: 'https://readdy.ai/api/search-image?query=Golden%20Rooster%20Film%20Awards%20ceremony%20stage%20with%20warm%20spotlights%2C%20elegant%20red%20and%20gold%20decor%2C%20prestigious%20atmosphere%2C%20cinematic%20lighting%2C%20trophy%20silhouette%2C%20artistic%20blur&width=600&height=340&seq=card-2&orientation=landscape',
  },
  {
    id: 3,
    title: '仙侠剧服化道进化史',
    tag: '深度策划',
    desc: '从《仙剑奇侠传》到《苍兰诀》，二十年国产仙侠剧在视觉美学上的蜕变与创新之路。',
    image: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20drama%20costume%20with%20flowing%20silk%2C%20celestial%20palace%20background%2C%20soft%20misty%20lighting%2C%20pastel%20and%20gold%20tones%2C%20dreamy%20atmosphere%2C%20artistic%20composition&width=600&height=340&seq=card-3&orientation=landscape',
  },
  {
    id: 4,
    title: '国产谍战剧十强榜单',
    tag: '观剧指南',
    desc: '《潜伏》《风筝》《伪装者》领衔，盘点国产谍战剧史上口碑与收视双丰收的十部经典。',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20Chinese%20spy%20drama%20atmosphere%2C%20old%20Shanghai%20street%20scene%2C%20trench%20coat%20silhouette%2C%20warm%20sepia%20tones%2C%20film%20noir%20lighting%2C%20suspenseful%20mood%2C%20retro%20aesthetic&width=600&height=340&seq=card-4&orientation=landscape',
  },
  {
    id: 5,
    title: '方言电影：最地道的中国味',
    tag: '冷门佳片',
    desc: '四川话、上海话、粤语……当角色说着家乡话时，电影里的人情味与烟火气扑面而来。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20Chinese%20neighborhood%20street%20scene%2C%20local%20market%20with%20red%20lanterns%2C%20everyday%20life%20atmosphere%2C%20golden%20afternoon%20light%2C%20nostalgic%20film%20photography%20style%2C%20authentic%20cultural%20scene&width=600&height=340&seq=card-5&orientation=landscape',
  },
  {
    id: 6,
    title: '央视开年大剧《北上》热播中',
    tag: '新剧速递',
    desc: '改编自徐则臣茅盾文学奖同名小说，白宇、欧豪领衔主演，讲述运河人家的百年沧桑。',
    image: 'https://readdy.ai/api/search-image?query=Grand%20Canal%20China%20scenery%20with%20traditional%20boats%2C%20warm%20sunset%20light%2C%20riverside%20town%2C%20cinematic%20wide%20shot%2C%20golden%20hour%20glow%2C%20period%20drama%20aesthetic%2C%20peaceful%20atmosphere&width=600&height=340&seq=card-6&orientation=landscape',
  },
  {
    id: 7,
    title: '国产动画崛起：年度十佳盘点',
    tag: '国漫之光',
    desc: '从《哪吒》《深海》到《长安三万里》，国产动画电影技术与叙事的全面飞跃。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20with%20ink%20wash%20painting%20aesthetic%2C%20mythical%20creatures%2C%20flowing%20brushwork%2C%20vibrant%20colors%20with%20gold%20accents%2C%20artistic%20composition%2C%20modern%20oriental%20fantasy%20style&width=600&height=340&seq=card-7&orientation=landscape',
  },
];

export const updatesData = [
  { id: 1, date: '07-30', title: '《北上》第18-19集更新上线', tag: '剧集更新' },
  { id: 2, date: '07-30', title: '暑期档特别策划《国片新生代》专题发布', tag: '专题' },
  { id: 3, date: '07-29', title: '纪录片专区新增《航拍中国》第四季全10集', tag: '片库上新' },
  { id: 4, date: '07-29', title: '移动端播放器升级，支持手势控制与画中画', tag: '功能升级' },
  { id: 5, date: '07-28', title: '《漫长的季节》导演剪辑版独家上线', tag: '独家资源' },
  { id: 6, date: '07-28', title: '本周热播榜：《北上》蝉联榜首，《大奉打更人》紧随其后', tag: '热榜' },
  { id: 7, date: '07-27', title: '金鸡奖获奖影片《第二十条》全网首播', tag: '首播' },
  { id: 8, date: '07-27', title: '喜剧片专区整理完成，新增分类标签与评分系统', tag: '体验优化' },
  { id: 9, date: '07-26', title: '站内搜索升级，支持按演员、导演、年份多维检索', tag: '功能升级' },
];

export const topicsData = [
  { id: 1, name: '2026暑期档', hot: true },
  { id: 2, name: '国产悬疑', hot: true },
  { id: 3, name: '古装大剧', hot: true },
  { id: 4, name: '综艺搞笑', hot: false },
  { id: 5, name: '高分纪录片', hot: true },
  { id: 6, name: '谍战经典', hot: false },
  { id: 7, name: '武侠回忆', hot: false },
  { id: 8, name: '仙侠美学', hot: false },
  { id: 9, name: '方言电影', hot: false },
  { id: 10, name: '国漫崛起', hot: true },
  { id: 11, name: '年代剧', hot: false },
];

export const rankingData = [
  { rank: 1, title: '北上', type: '电视剧', score: '9.2', tag: '热播中' },
  { rank: 2, title: '漫长的季节', type: '电视剧', score: '9.4', tag: '经典' },
  { rank: 3, title: '第二十条', type: '电影', score: '8.7', tag: '金鸡奖' },
  { rank: 4, title: '大奉打更人', type: '电视剧', score: '8.5', tag: '热议' },
  { rank: 5, title: '长安三万里', type: '电影', score: '8.9', tag: '国漫' },
];

export const faqData = [
  {
    id: 1,
    question: '91在线视频是否需要注册才能观看？',
    answer: '不需要。91在线视频全站内容免费开放，无需注册即可在线观看所有国产电影、电视剧和综艺节目。如果您希望使用收藏、历史记录和评论等个性化功能，可以选择免费注册账号。',
  },
  {
    id: 2,
    question: '视频播放卡顿或缓冲怎么办？',
    answer: '我们采用智能CDN加速和多线路备份技术，确保流畅播放。如遇卡顿，建议：① 切换视频清晰度（播放器右下角设置）；② 检查网络连接状态；③ 清除浏览器缓存后刷新页面。大部分情况下切换线路即可解决。',
  },
  {
    id: 3,
    question: '更新频率是怎样的？新剧什么时候上线？',
    answer: '我们的内容运营团队7×24小时工作，国产剧集通常在电视台播出后2-4小时内上线，热门综艺次日更新。电影方面，院线下映后1-3个月内陆续上架。每日更新量超过60部/集。',
  },
  {
    id: 4,
    question: '支持哪些设备观看？可以投屏吗？',
    answer: '91在线视频支持电脑（Windows/Mac）、平板（iPad/Android）和手机（iOS/Android）全平台观看。播放器内置投屏功能，支持DLNA和AirPlay协议，可投屏至智能电视和投影仪，享受大屏观影体验。',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '《北上》运河风云录',
    desc: '茅盾文学奖作品改编，白宇、欧豪演绎百年运河传奇',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20traditional%20Chinese%20riverside%20town%20at%20sunset%2C%20warm%20golden%20light%2C%20canal%20with%20wooden%20boats%2C%20period%20drama%20costumes%2C%20soft%20lens%20flare%2C%20film%20grain%20aesthetic%2C%20rich%20atmospheric%20mood&width=640&height=360&seq=media-1&orientation=landscape',
    duration: '45:22',
    views: '328万',
  },
  {
    id: 2,
    title: '金鸡奖最佳影片《第二十条》',
    desc: '张艺谋导演现实主义力作，雷佳音、马丽主演',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20courtroom%20drama%20scene%20with%20warm%20interior%20lighting%2C%20lawyer%20in%20robe%2C%20dramatic%20shadows%2C%20cinematic%20composition%2C%20film%20still%20aesthetic%2C%20serious%20atmosphere%2C%20professional%20legal%20setting&width=640&height=360&seq=media-2&orientation=landscape',
    duration: '141:00',
    views: '896万',
  },
  {
    id: 3,
    title: '《航拍中国》第四季·西藏篇',
    desc: '世界屋脊的壮美航拍，大自然的鬼斧神工',
    image: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Tibetan%20plateau%20mountains%20with%20golden%20sunlight%2C%20snow%20capped%20peaks%2C%20vast%20landscape%2C%20dramatic%20clouds%2C%20cinematic%20drone%20photography%20style%2C%20breathtaking%20natural%20scenery%2C%20warm%20earthy%20tones&width=640&height=360&seq=media-3&orientation=landscape',
    duration: '50:18',
    views: '512万',
  },
];